<template>
<div class="chapter">
<div class="inner_page">
<p class="toc">C<span class="small">ONTENTS</span></p>
<p class="cct" id="ch1"><a href="#/chapter1#c11">PART ONE</a></p>
<p class="cct" id="c1"><a href="#/chapter1#c01">Chapter 1</a></p>
<p class="cct" id="c2"><a href="#/chapter2#c02">Chapter 2</a></p>
<p class="cct" id="c3"><a href="#/chapter3#c03">Chapter 3</a></p>
<p class="cct" id="c4"><a href="#/chapter4#c04">Chapter 4</a></p>
<p class="cct" id="c5"><span href="#/chapter5#c05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="cct" id="c6"><span href="#/chapter6#c06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="cct" id="ch7"><span href="#/chapter7#c22" title="Link target outside of Sample">PART TWO</span></p>
<p class="cct" id="c7"><span href="#/chapter7#c07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="cct" id="c8"><span href="#/chapter8#c08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="cct" id="c9"><span href="#/chapter9#c09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="cct" id="c10"><span href="#/chapter10#c010" title="Link target outside of Sample">Chapter 10</span></p>
<p class="cct" id="ch11"><span href="#/chapter11#c33" title="Link target outside of Sample">PART THREE</span></p>
<p class="cct" id="c11"><span href="#/chapter11#c011" title="Link target outside of Sample">Chapter 11</span></p>
<p class="cct" id="c12"><span href="#/chapter12#c012" title="Link target outside of Sample">Chapter 12</span></p>
<p class="cct" id="c13"><span href="#/chapter13#c013" title="Link target outside of Sample">Chapter 13</span></p>
<p class="cct" id="c14"><span href="#/chapter14#c014" title="Link target outside of Sample">Chapter 14</span></p>
<p class="cct" id="c15"><span href="#/chapter15#c015" title="Link target outside of Sample">Chapter 15</span></p>
<p class="cct" id="c16"><span href="#/chapter16#c016" title="Link target outside of Sample">Chapter 16</span></p>
<p class="cct" id="c17"><span href="#/chapter17#c017" title="Link target outside of Sample">Chapter 17</span></p>
<p class="cct" id="ch18"><span href="#/chapter18#c44" title="Link target outside of Sample">PART FOUR</span></p>
<p class="cct" id="c18"><span href="#/chapter18#c018" title="Link target outside of Sample">Chapter 18</span></p>
<p class="cct" id="c19"><span href="#/chapter19#c019" title="Link target outside of Sample">Chapter 19</span></p>
<p class="cct" id="c20"><span href="#/chapter20#c020" title="Link target outside of Sample">Chapter 20</span></p>
<p class="cct" id="c21"><span href="#/chapter21#c021" title="Link target outside of Sample">Chapter 21</span></p>
<p class="cct" id="c22"><span href="#/chapter22#c022" title="Link target outside of Sample">Chapter 22</span></p>
<p class="cct" id="ch23"><span href="#/chapter23#c55" title="Link target outside of Sample">PART FIVE</span></p>
<p class="cct" id="c23"><span href="#/chapter23#c023" title="Link target outside of Sample">Chapter 23</span></p>
<p class="cct" id="c24"><span href="#/chapter24#c024" title="Link target outside of Sample">Chapter 24</span></p>
<p class="cct" id="c25"><span href="#/chapter25#c025" title="Link target outside of Sample">Chapter 25</span></p>
<p class="cct" id="c26"><span href="#/chapter26#c026" title="Link target outside of Sample">Chapter 26</span></p>
<p class="cct" id="c27"><span href="#/chapter27#c027" title="Link target outside of Sample">Chapter 27</span></p>
<p class="cct" id="c28"><span href="#/chapter28#c028" title="Link target outside of Sample">Chapter 28</span></p>
<p class="cct" id="ch29"><span href="#/chapter29#c66" title="Link target outside of Sample">PART SIX</span></p>
<p class="cct" id="c29"><span href="#/chapter29#c029" title="Link target outside of Sample">Chapter 29</span></p>
<p class="cct" id="c30"><span href="#/chapter30#c030" title="Link target outside of Sample">Chapter 30</span></p>
<p class="cct" id="c31"><span href="#/chapter31#c031" title="Link target outside of Sample">Chapter 31</span></p>
<p class="cct" id="c32"><span href="#/chapter32#c032" title="Link target outside of Sample">Chapter 32</span></p>
<p class="cct" id="c33"><span href="#/chapter33#c033" title="Link target outside of Sample">Chapter 33</span></p>
<p class="cct" id="c34"><span href="#/chapter34#c034" title="Link target outside of Sample">Chapter 34</span></p>
<p class="cct" id="ch35"><span href="#/chapter35#c77" title="Link target outside of Sample">PART SEVEN</span></p>
<p class="cct" id="c35"><span href="#/chapter35#c035" title="Link target outside of Sample">Chapter 35</span></p>
<p class="cct" id="c36"><span href="#/chapter36#c036" title="Link target outside of Sample">Chapter 36</span></p>
<p class="cct" id="c04"><span href="#/bio#c4" title="Link target outside of Sample">A Biography of Iris Murdoch</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?88385caa